// eslint-disable-next-line import/prefer-default-export
export const muiInputLabelComponent = {
  styleOverrides: {
    root: () => ({
      maxWidth: '100%',
      position: 'relative',
      transform: 'none',
    }),
  },
};
